export default function dateFormateUpdate(timestamp) {
  const date = new Date(timestamp);

  // Function to pad single digits with a leading zero
  const pad = (num) => num.toString().padStart(2, "0");

  // Options for month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Extract date components
  const month = monthNames[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours();
  const minutes = pad(date.getUTCMinutes());

  // Format the time in 12-hour format
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  // Format the date and time
  return `${month} ${day}, ${year} ${formattedHours}:${minutes} ${period} GMT`;
}

export function dateFormatWithAt(timestamp) {
  const updatedOnDate = new Date(timestamp);
  return `${(updatedOnDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${updatedOnDate
    .getDate()
    .toString()
    .padStart(2, "0")}-${updatedOnDate.getFullYear()} at ${updatedOnDate
    .toLocaleTimeString("en-US", {
      hour12: false,
    })
    .toLowerCase()}`;
}

export function dateFormatWithSubject(timestamp) {
  const updatedOnDate = new Date(timestamp);
  return `${(updatedOnDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${updatedOnDate
    .getDate()
    .toString()
    .padStart(2, "0")}-${updatedOnDate.getFullYear()} ${updatedOnDate
    .toLocaleTimeString("en-US", {
      hour12: false,
    })
    .toLowerCase()}`;
}

export function dateFormatGMTToLocalDateTime(dateTime) {
  const updatedOnDate = new Date(dateTime);
  return `${(updatedOnDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${updatedOnDate
    .getDate()
    .toString()
    .padStart(2, "0")}-${updatedOnDate.getFullYear()} at ${updatedOnDate
    .toLocaleTimeString("en-US", {
      hour12: false,
    })
    .toLowerCase()}`;
}
